(function () {
    'use strict';

    angular
        .module('app.account-numeric-files', [])

        .component('accountNumericFiles', {
            bindings: {
                device: '<'
            },
            /* @ngInject */
            templateUrl: ["AccountService", function (AccountService) {
                return AccountService.getLinks().AccountNumericFiles;
            }],

            controllerAs: 'accountCtrl',
            /* @ngInject */
            controller: ["$scope", "HttpService", "AccountService", "$timeout", function ($scope, HttpService, AccountService, $timeout) {
                var ctrl = this;

                AccountService.initAccount(ctrl);

                ctrl.$onInit = function () {

                    $scope.device = ctrl.device;
                    ctrl.loading = true;

                    HttpService.get({
                        url: '/compte/fiches-techniques/list',
                        cache: false
                    })
                        .then(function (response) {

                            ctrl.products = response;
                            console.log(response);

                            if (ctrl.products.length > 0) {
                                $timeout(function () {
                                    ctrl.products[0].isOpen = true;
                                }, 1000);
                            }

                            ctrl.loading = false;
                            
                        })
                        .catch(function (error) {
                            console.error(error);
                        });
                };

            }]
        });

})();
